import {utils} from '@wallaby-ui/core';
import classNames, {Argument} from 'classnames';
import * as React from 'react';
import {useIntl} from 'react-intl';

import styles from './AgGridFilterButton.less';
import {FilterButtonConfig} from 'src/js/model/filter_button_config';

interface OwnProps {
  filterButtonConfig: FilterButtonConfig;
  className?: Argument;
  handleClick: (filterButtonConfig: FilterButtonConfig) => void;
  isClicked?: boolean;
  isDisabled?: boolean;
  tabIndex?: number;
}

type Props = OwnProps;

export const AgGridFilterButton: React.FC<Props> = (props) => {
  const {
    className = '',
    filterButtonConfig,
    isDisabled = false,
    isClicked = false,
    handleClick,
    tabIndex = 0,
  } = props;

  const intl = useIntl();

  const handleButtonClick = (event) => {
    if (event) {
      event.stopPropagation();
    }
    handleClick(filterButtonConfig);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      handleClick(filterButtonConfig);
    }
    return true;
  };

  return (
    <button
      type={'button'}
      className={classNames(
        className,
        styles.dlAgGridFilterButton,
        'float-end',
        {
          [styles.dlDisabledButton]: isDisabled,
          [styles.dlClickedButton]: isClicked,
        }
      )}
      title={utils.TranslateUtils.translate(
        {id: filterButtonConfig.getTitle()},
        intl
      )}
      onClick={handleButtonClick}
      onKeyDown={handleKeyDown}
      disabled={isDisabled}
      tabIndex={tabIndex}
      data-name={`filterButton-${filterButtonConfig.getLabel()}`}
    >
      {utils.TranslateUtils.translate(
        {id: filterButtonConfig.getLabel()},
        intl
      )}
    </button>
  );
};

AgGridFilterButton.displayName = 'AgGridFilterButton';
